<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Theo dõi thiết bị thuê và đổi trả</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37 text-search"
              placeholder="ID cho thuê"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              :show-week-numbers="false"
              v-model="dateRangeFrom"
              :locale-data="Config.localeData"
              :timePicker="false"
              :timePicker24Hour="false"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày thuê từ
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              :show-week-numbers="false"
              v-model="dateRangeTo"
              :locale-data="Config.localeData"
              :timePicker="false"
              :timePicker24Hour="false"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày thuê đến
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <datepicker
              v-model="dateRangeMonth"
              format="MM/yyyy"
              class="form_fix"
              :minimumView="'month'"
              :maximumView="'month'"
              :language="vi"
              placeholder="Tháng kinh doanh"
              :clearButton="true"
            >
            </datepicker>
          </div>

          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="fetchData"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(rentId)="data">
                {{ data.item.rentId ? data.item.rentId : '' }}
              </template>
              <template #cell(serial)="data">
                {{ data.item.serial ? data.item.serial : '' }}
              </template>
              <template #cell(dateFrom)="data">
                <span v-if="data.item.contractKeyInfo && data.item.contractKeyInfo[0].applyDate">{{
                  data.item.contractKeyInfo[0].applyDate | formatDate
                }}</span>
              </template>
              <template #cell(dateTo)="data">
                <span v-if="data.item.contractKeyInfo && data.item.contractKeyInfo[0].endedDate">{{
                  data.item.contractKeyInfo[0].endedDate | formatDate
                }}</span>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { DeviceService } from '@/services/device.service'
  import { vi } from 'vuejs-datepicker/dist/locale'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'rentId', label: 'ID cho thuê' },
    { key: 'serial', label: 'Serial thiết bị' },
    { key: 'dateFrom', label: 'Ngày thuê từ' },
    { key: 'dateTo', label: 'Ngày thuê đến' },
  ]
  export default {
    data() {
      return {
        Config,
        vi,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        dataConfigRegion: [],
        search: {
          code: '',
          serial: '',
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dateRangeFrom: {
          startDate: null,
          endDate: null,
        },
        dateRangeTo: {
          startDate: null,
          endDate: null,
        },
        dateRangeMonth: '',
      }
    },
    watch: {},
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRangeFrom = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeTo = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeMonth = ''
        this.selected = []
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          this.formatData()
          const response = await DeviceService.getListRentalandReturn(this.search)
          if (response.code === 1000) {
            this.lists = response.data ? response.data : []
            this.pagination.total =
              response.totalPage && response.totalPage.total ? response.totalPage.total : 0
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
      async formatData() {
        if (this.dateRangeFrom.startDate) {
          this.search.rentalDateFromStart = moment(this.dateRangeFrom.startDate)
            .startOf('day')
            .add(7, 'hours')
        } else delete this.search.rentalDateFromStart
        if (this.dateRangeFrom.endDate) {
          this.search.rentalDateFromEnd = moment(this.dateRangeFrom.endDate)
            .endOf('day')
            .add(7, 'hours')
        } else delete this.search.rentalDateFromEnd

        if (this.dateRangeTo.startDate) {
          this.search.rentalDateToStart = moment(this.dateRangeTo.startDate)
            .startOf('day')
            .add(7, 'hours')
        } else delete this.search.rentalDateToStart
        if (this.dateRangeTo.endDate) {
          this.search.rentalDateToEnd = moment(this.dateRangeTo.endDate)
            .endOf('day')
            .add(7, 'hours')
        } else delete this.search.rentalDateToEnd

        if (this.dateRangeMonth && this.dateRangeMonth != '') {
          const currentMonth = moment(this.dateRangeMonth).month()
          this.search.monthFrom = moment()
            .month(currentMonth - 1)
            .date(25)
            .startOf('day')
            .add(7, 'hours')
            .toISOString()
          this.search.monthTo = moment()
            .month(currentMonth)
            .date(24)
            .endOf('day')
            .add(7, 'hours')
            .toISOString()
        } else {
          delete this.search.monthFrom
          delete this.search.monthTo
        }

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
      },
      setSearch(code) {
        this.search.code = code
        this.search.page = 1
        this.fetchData()
      },
    },
  }
</script>

<style scoped>
  .form_fix input {
    border-radius: 4px;
    border-color: #ced4da;
  }

  .form_fix input::placeholder {
    color: #999999 !important;
  }
</style>
